import React from 'react'
import Sidebar from "../Sidebar"
import AdminManagement from './AdminManagement';


function Events() {
  return (
    <div>
      
        <Sidebar />
        
        <AdminManagement />
        
    </div>
  )
}

export default Events